import { createSelector } from '@reduxjs/toolkit';

import { citiesSelector } from 'redux/selectors/regionSelectors';
import { useAppSelector } from 'hooks/useAppSelector';

const getLocation = (...locations: (string | number | undefined)[]) => {
  return locations.filter(Boolean).join(', ');
};

const createCitiesSelector = () =>
  createSelector(
    [
      (args: { stateId?: number }) => args.stateId,
      () => useAppSelector(citiesSelector),
    ],
    (stateId, cities) => cities.filter((city) => city.stateId === stateId),
  );

export { getLocation, createCitiesSelector };
